import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import AccountCircle from '@mui/icons-material/AccountCircle';

import CssBaseline from '@mui/material/CssBaseline';
import RSLogo from '../../assets/images/realstar.png'

import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Logout from '@mui/icons-material/Logout';
import { Link } from "react-router-dom";
import { Button } from '@mui/material';
import {useNavigate} from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

function Header() {
  const {auth} = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar
        position="sticky"
        color="default"
        elevation={0}
        sx={{
          position: 'sticky',
          borderBottom: (t) => `1px solid ${t.palette.divider}`
        }}
      >
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Link to={'/'}>
              <img src={RSLogo} alt='rslogo' height={70} width={ 170 }></img>
            </Link>
          </Typography>
        
          {auth.valid && 
          <>
           <Typography variant="h6" sx={{ mr: 2 }}>
            <Button sx={{ color: 'black' }} onClick={ () => { navigate('/') }}>
                {'My Submission'}
            </Button>
          </Typography>
          <Typography variant="h6" sx={{ mr: 2 }}>
            <Button sx={{ color: 'black' }} onClick={() => { window.location.href = 'https://crm.realstarpremier.com/esubmission' }}>
                {'Exit'}
            </Button>
          </Typography>
          <div>

            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar src={auth.avatar ? auth.avatar : "" } />
            </IconButton>
            {/* <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&::before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem onClick={handleClose}>
                <Avatar/> Profile
              </MenuItem>
              <MenuItem onClick={ () => navigate('/admin/forms/create')}>
                <Avatar /> Templates
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>

            </Menu> */}

          </div>
          </>
          }
        </Toolbar>
      </AppBar>
    </React.Fragment>

  );
}
export default Header;